import { Moon, Sun, Bell } from 'lucide-react';
import { cn } from '../../lib/cn';
import { useTheme } from '../../hooks/useTheme';
import { Button } from '../ui/Button';

interface HeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
}

/**
 * Admin dashboard header with page title and actions.
 */
export function Header({ title, description, actions }: HeaderProps) {
  const { isDark, toggleTheme } = useTheme();

  return (
    <header
      className={cn(
        'h-14 px-6',
        'bg-surface',
        'border-b border-border',
        'flex items-center justify-between',
        'sticky top-0 z-20'
      )}
    >
      {/* Page title */}
      <div>
        <h1 className="text-section-title text-text">
          {title}
        </h1>
        {description && (
          <p className="text-caption text-text-secondary">
            {description}
          </p>
        )}
      </div>

      {/* Actions */}
      <div className="flex items-center gap-2">
        {actions}

        {/* Notifications */}
        <Button
          variant="ghost"
          size="sm"
          className="relative"
          aria-label="Notifications"
        >
          <Bell size={18} />
          {/* Notification dot */}
          <span className="absolute top-1 right-1 w-2 h-2 bg-loss rounded-full" />
        </Button>

        {/* Theme toggle */}
        <Button
          variant="ghost"
          size="sm"
          onClick={toggleTheme}
          aria-label={isDark ? 'Switch to light mode' : 'Switch to dark mode'}
        >
          {isDark ? <Sun size={18} /> : <Moon size={18} />}
        </Button>
      </div>
    </header>
  );
}
